(function () {
  let swiperAnnouncement;
  const announcementSwipeEnabled = document.querySelector(
    ".swiper-announcement-bar"
  );

  const addClasses = () => {
    const slides = document.querySelectorAll(".announcement-bar__item");
    slides.forEach((slide) => {
      slide.classList.add("swiper-slide");
    });
  };

  const initSlider = () => {
    swiperAnnouncement = new Swiper(".swiper-announcement-bar", {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 0,
      speed: 500,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      loop: true,
      breakpoints: {
        600: {
          slidesPerView: 2,
          slidesPerGroup: 2,
        },
      },
    });
  };

  const destroySlider = () => {
    const slides = document.querySelectorAll(".announcement-bar__item");

    if (Array.isArray(swiperAnnouncement)) {
      swiperAnnouncement.forEach((swiper) => {
        swiper.destroy(true, true);
      });
    } else {
      swiperAnnouncement.destroy(true, true);
    }
    swiperAnnouncement = null;

    slides.forEach((slide) => {
      slide.removeAttribute("style");
      slide.classList.remove("swiper-slide");
    });
  };

  const initAnnouncement = () => {
    const announcementSection = document.querySelector(".header");

    const sectionResizeObserver = new ResizeObserver((entries) => {
      const [entry] = entries;

      if (entry.contentRect.width < 900 && announcementSwipeEnabled) {
        addClasses();
        initSlider();
      } else if (swiperAnnouncement) {
        destroySlider();
      }
    });

    sectionResizeObserver.observe(announcementSection);
  };

  if (swiperAnnouncement) {
    destroySlider();
  }
  addClasses();
  initAnnouncement();
  initSlider();
  document.addEventListener("shopify:section:load", function () {
    if (swiperAnnouncement) {
      destroySlider();
    }
    addClasses();
    initAnnouncement();
    initSlider();
  });
})();

(function () {
  let swiperCollection;

  const initSlider = () => {
    swiperCollection = new Swiper(".swiper-subcollections", {
      slidesPerView: 2,
      slidesPerGroup: 1,
      spaceBetween: 20,
      loop: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        480: {
          slidesPerView: 3,
        },
        720: {
          slidesPerView: 4,
          spaceBetween: 28,
        },
        999: {
          slidesPerView: 5,
        },
        1400: {
          slidesPerView: 6,
        },
      },
    });
  };

  initSlider();
  document.addEventListener("shopify:section:load", function () {
    initSlider();
  });
})();
